import {
  BookingListQueryVariables,
  BookingRelocationMatchType,
  BookingStatus,
  QueryBookingsOrderByColumn,
  QueryBookingsOrderByRelationOrderByClause,
  RelocationType,
  SortOrder,
} from "@/gql/graphql";
import {
  GetQueryVariablesFn,
  SortingState,
} from "@/lib/Components/DataTable/DataTable";
import type { BookingColumnId } from "@/app/Dashboard/Components/BookingTable";

// Shared by the table and its route loaders — both must request the same order
// or the preloaded query key won't match the component's.
export const bookingTableDefaultSorting: SortingState<BookingColumnId> = [
  { id: "created_at", desc: true },
];

const sortMap: Partial<{
  [key in BookingColumnId]: QueryBookingsOrderByColumn;
}> = {
  status: QueryBookingsOrderByColumn.Status,
  created_at: QueryBookingsOrderByColumn.CreatedAt,
  booking: QueryBookingsOrderByColumn.Reference,
  dates: QueryBookingsOrderByColumn.DepartAt,
  customer: QueryBookingsOrderByColumn.Name,
  journey: QueryBookingsOrderByColumn.DepartAt,
};
export function getBookingTableVariables({
  supplierId,
  status,
  departureCityIds,
  deliveryCityIds,
  vehicles,
  relocationTypes,
  hasMatches,
  queryVariables,
}: {
  supplierId: string | null;
  status: BookingStatus[];
  departureCityIds: string[];
  deliveryCityIds: string[];
  vehicles: string[];
  relocationTypes: RelocationType[];
  hasMatches?: BookingRelocationMatchType | null;
  queryVariables?: Partial<BookingListQueryVariables>;
}): GetQueryVariablesFn<BookingListQueryVariables, BookingColumnId> {
  return ({ search, pagination, sorting }) => {
    if (search) {
      return {
        supplierId: supplierId ?? undefined,
        first: pagination.pageSize,
        page: pagination.pageIndex,
        status: status.length > 0 ? status : undefined,
        relocationType: relocationTypes.length ? relocationTypes : undefined,
        departureCityIds: departureCityIds.length
          ? departureCityIds
          : undefined,
        deliveryCityIds: deliveryCityIds.length ? deliveryCityIds : undefined,
        search,
      };
    }

    const orderBy: QueryBookingsOrderByRelationOrderByClause[] = [];

    sorting.forEach((s) => {
      const order = s.desc ? SortOrder.Desc : SortOrder.Asc;

      if (sortMap[s.id]) {
        orderBy.push({
          column: sortMap[s.id],
          order,
        });

        return;
      }

      console.log(`Not sort configured for ${s.id}`);
    });

    return {
      supplierId: supplierId ?? undefined,
      first: pagination.pageSize,
      page: pagination.pageIndex,
      departureCityIds: departureCityIds.length ? departureCityIds : undefined,
      deliveryCityIds: deliveryCityIds.length ? deliveryCityIds : undefined,
      vehicleIds: vehicles.length ? vehicles : undefined,
      relocationType: relocationTypes.length ? relocationTypes : undefined,
      search: search || undefined,
      status: status.length > 0 ? status : undefined,
      hasMatches: hasMatches || undefined,
      orderBy: orderBy,
      ...queryVariables,
    } satisfies BookingListQueryVariables;
  };
}
